import { NgModule } from '@angular/core'
import {
  AnonymousConsentTemplatesAdapter,
  OccAnonymousConsentTemplatesAdapter,
  provideConfig,
  SiteContextConfig
} from '@spartacus/core'
import { defaultB2bOccConfig } from '@spartacus/setup'
import { defaultCmsContentProviders, mediaConfig, PaginationConfig } from '@spartacus/storefront'
import { customLayoutConfig } from '../features/config/custom-layout.config'

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideConfig(customLayoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig(defaultB2bOccConfig),
    provideConfig(<SiteContextConfig>{
      context: {
        urlParameters: ['custom'],
        language: ['en'],
        baseSite: ['asaleocare-au', 'asaleocare-nz'],
        currency: ['AUD', 'NZD'],
        custom: ['au', 'nz', 'AU', 'NZ']
      }
    }),
    {
      provide: AnonymousConsentTemplatesAdapter,
      useClass: OccAnonymousConsentTemplatesAdapter
    },
    provideConfig(<PaginationConfig>{
      pagination: {
        addStart: true,
        addPrevious: false,
        addEnd: true,
        addNext: false,
        addFirst: false,
        addLast: false,
        addDots: false,
        rangeCount: 3
      }
    })
  ]
})
export class SpartacusConfigurationModule {}
